import React from 'react';

import { gettext } from '../translations';

import Button from 'eventbrite_design_system/button/Button';
import ChevronDown from 'eventbrite_design_system/iconography/icons/ChevronDown';
import Icon from 'eventbrite_design_system/icon/Icon';

import { scrollIt } from '../utils/random';

import './BrowsePageButton.scss';

const BrowsePageButton = ({ handleTrackPageButton, shouldShowAnimation }) => {
    const handleOnClick = () => {
        if (handleTrackPageButton) {
            handleTrackPageButton();
        }

        scrollIt(document.querySelector('.browse-section').offsetTop + 70);
    };

    let iconComponent = (
        <Icon
            type={<ChevronDown />}
            size="small"
            width="24"
            height="24"
            color="ui-600"
        />
    );

    if (shouldShowAnimation) {
        iconComponent = (
            <div className="mouse-container">
                <div className="mouse" />
            </div>
        );
    }

    return (
        <div className="browse-events">
            <Button type="button" style="none" onClick={handleOnClick}>
                {gettext('Browse other popular events')}
                {iconComponent}
            </Button>
        </div>
    );
};

export default BrowsePageButton;
